export default {"src":"/_next/static/media/dpd_logo.a9fdec29.svg","height":23,"width":50,"blurWidth":0,"blurHeight":0};